import React from "react";
import { Link, useParams } from "react-router-dom";
import "./Web1920116.css";
import nasalogo from "../../static/img/NASA_Insignia.png";

function Web1920116(props) {
  let { videoIndex } = useParams();
  const { backToImage, jupiter_video, saturn_video, jupiter_video_new } = props;
  let video = null;
  if (videoIndex === '1') {
    video = jupiter_video
  } else if (videoIndex === '2') {
    video = saturn_video
  } else if (videoIndex === '2') {
    video = saturn_video
  }
  else if (videoIndex === '3') {
    video = jupiter_video_new
  }
  return (
    <div className="container-center-horizontal video">
      <div className="web-1920-116 screen">
        <div className="overlap-group1-12">
          <video  loop={true} autoPlay muted playsInline webkit-playsinline={1}>
            <source src={video} type="video/mp4" />
            </video>
          <Link to="/web-1920-27/0">
            <div className="group-142-5">
              <div className="overlap-group-25">
                <div className="rectangle-33-10 border-3px-picton-blue">
                  <div className="back-to-image-3 lato-medium-white-13px">{backToImage}</div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <a href="https://www.nasa.gov/" className="nasalogo" target="_blank"  rel="noreferrer"><img alt="img" src={nasalogo} /> </a>

    </div>
  );
}

export default Web1920116;
